import React from 'react';
import { CustomHeroButton } from '../../../../components';
import { ActionsCellProps } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';

const ActionsCell: React.FC<ActionsCellProps> = ({ offer, onOpenOffer }) => {
  const { t } = useTranslations();

  return (
    <CustomHeroButton
      size="sm"
      className="!bg-[#F1E8FF] !text-xs !font-normal w-[6.25rem] !text-primary h-8 rounded-2 px-3"
      onPress={() => onOpenOffer(offer)}
      title={t('revshare.table.open')}
    />
  );
};

export default ActionsCell;
